module.exports = __webpack_public_path__ + "img/config.642910f4.svg";